const VERSION_REGEX = /^\d+(\.\d+){0,2}$/;

/** File name produced by CI, e.g. `swv-mill_3.48.0-146.apk`. */
const APK_FILE_NAME_REGEX = /_(\d+\.\d+\.\d+)-(\d+)\.apk$/i;

export const isValidVersion = (value: string) =>
	VERSION_REGEX.test(value.trim());

const parseVersion = (value: string) =>
	value
		.trim()
		.split(".")
		.map((part) => Number.parseInt(part, 10) || 0);

/** Negative when a < b, zero when equal, positive when a > b. */
export const compareVersions = (a: string, b: string) => {
	const left = parseVersion(a);
	const right = parseVersion(b);
	const length = Math.max(left.length, right.length, 3);

	for (let i = 0; i < length; i++) {
		const diff = (left[i] ?? 0) - (right[i] ?? 0);
		if (diff !== 0) {
			return diff;
		}
	}

	return 0;
};

export const parseApkFileName = (
	fileName: string,
): { version: string; build: number } | null => {
	const match = APK_FILE_NAME_REGEX.exec(fileName);

	if (!match) {
		return null;
	}

	return { version: match[1], build: Number(match[2]) };
};

export const formatFileSize = (bytes?: number | null) => {
	if (bytes == null) {
		return "";
	}

	if (bytes < 1024) {
		return `${bytes} B`;
	}

	const units = ["KB", "MB", "GB"];
	let value = bytes / 1024;
	let unit = 0;

	while (value >= 1024 && unit < units.length - 1) {
		value /= 1024;
		unit++;
	}

	return `${value.toFixed(1)} ${units[unit]}`;
};
